import React, { useEffect, useRef, useState } from "react";
import logo from "../assets/images/logo/logo.png";
import logoSticky from "../assets/images/logo/logo-2.png";
import { Image } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";

const menuItems = [
  { label: "Ana Sayfa", value: "home" },
  { label: "Hakkımızda", value: "about" },
  { label: "Fiyatlandırma", value: "pricing" },
  { label: "Takım", value: "team" },
  { label: "İletişim", value: "contact" },
];

export default function Header() {
  const headerRef = useRef(null);

  const [isSticky, setIsSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  // ===== Sticky + BackToTop + Active Menu
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      if (headerRef.current) {
        setIsSticky(scrollY > headerRef.current.offsetTop);
      }

      setShowBackToTop(scrollY > 50);

      menuItems.forEach(({ value }) => {
        const section = document.getElementById(value);
        if (!section) return;

        const offsetTop = section.offsetTop - 80;
        const offsetBottom = offsetTop + section.offsetHeight;

        if (scrollY >= offsetTop && scrollY < offsetBottom) {
          setActiveSection(value);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ===== Smooth scroll
  const handleMenuClick = (e, value) => {
    e.preventDefault();
    setMenuOpen(false);

    const section = document.getElementById(value);
    if (!section) return;

    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  // ===== Scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <>
      <header
        ref={headerRef}
        className={`ud-header ${isSticky ? "sticky" : ""}`}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand-lg">
                {/* LOGO */}
                <a className="navbar-brand" href="/">
                  <Image
                    src={isSticky ? logoSticky : logo}
                    alt="Logo"
                    height={55}
                    objectFit="cover"
                    className="my-10"
                  />
                </a>

                {/* TOGGLER */}
                <button
                  className={`navbar-toggler ${menuOpen ? "active" : ""}`}
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  <span className="toggler-icon" />
                  <span className="toggler-icon" />
                  <span className="toggler-icon" />
                </button>

                {/* MENU */}
                <div className={`navbar-collapse ${menuOpen ? "show" : ""}`}>
                  <ul className="navbar-nav mx-auto">
                    {menuItems.map(({ label, value }) => (
                      <li className="nav-item" key={value}>
                        {isHomePage ? (
                          // Ana sayfadaysak #section scroll
                          <a
                            href={`#${value}`}
                            className={`ud-menu-scroll ${
                              activeSection === value ? "active" : ""
                            }`}
                            onClick={(e) => handleMenuClick(e, value)}
                          >
                            {label}
                          </a>
                        ) : (
                          // Başka sayfadaysak route ile yönlendir
                          <Link
                            to={value === "home" ? "/" : `/${value}`}
                            className="ud-menu-scroll"
                            onClick={() => setMenuOpen(false)}
                          >
                            {label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* BUTTONS */}
                <div className="navbar-btn d-none d-sm-inline-block">
                  <a
                    href="https://app.aidatplus.space"
                    target="_blank"
                    className="ud-main-btn ud-login-btn"
                  >
                    Panele Giriş Yap
                  </a>
                  <a
                    href="https://app.aidatplus.space/register"
                    className="ud-main-btn ud-white-btn"
                  >
                    Başvuru
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>

      {/* BACK TO TOP */}
      {showBackToTop && (
        <button className="back-to-top" onClick={scrollToTop}>
          ↑
        </button>
      )}
    </>
  );
}
